import styled from 'styled-components';
import {
  textUnderlineEffect,
  typographyBaseCss,
} from 'src/common/styles/typography';
import { Link } from 'react-router-dom';

export const SimpleLink = styled.a`
  ${typographyBaseCss};
  ${textUnderlineEffect};

  color: currentColor;
  cursor: pointer;
  display: inline-block;
  letter-spacing: unset;
  padding-top: 0;
  text-decoration: underline;
`;

export const StyledRouterLink = styled(Link)`
  ${typographyBaseCss};
  ${textUnderlineEffect};

  color: currentColor;
  cursor: pointer;
  display: inline-block;
  letter-spacing: unset;
  padding-top: 0;
  text-decoration: underline;
  color: ${({ theme }) => theme.text.primary};
  text-decoration: none;
`;
